import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../Components/PageTitle'
import { NoRecords } from '../../Components/Shimmer'
import { NavLink, useLocation } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
// import * as XLSX from 'xlsx'
// import { formatDateWithTime } from '../../Constants/constants';
import { ConfigContext } from '../../Context/ConfigContext'
import ToggleSwitch from '../../Components/ToggleSwitch'
import { currentDateAndTime, decodeData } from '../../Constants/constants'

const MailList = () => {
  const { apiURL, apiHeaderFile, apiHeaderJSON, permissions } = useContext(ConfigContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedData = queryParams.get("abs");
  const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

  const [rows, setRows] = useState([])
  const [pagination, setPagination] = useState({
    next: false,
    prev: false,
    page: 1,
    total_records: '',
    total_pages: '',
    limit: 10
  })
  const [loadingList, setLoadingList] = useState(false)
  const [clearAction, setClearAction] = useState(false)
  const [limitAction, setLimitAction] = useState(false)
  const limitOptions = [10, 25, 50, 100, 200, 500]

  const getList = async () => {
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}MailMaster/GetMailTemplateList`, {
        params: {
          limit: pagination?.limit,
          page: pagination?.page
          // keyword: filter?.keyword ,
          // checkHeadType: filter?.checkHeadType,
        },
        headers
      })
      .then(response => {
        const data = response.data
        console.log(response?.data)
        if (response.data.success === true) {
          setRows(data?.response?.data)
          setPagination({
            ...pagination,
            next: data?.response?.next,
            prev: data?.response?.prev,
            page: data?.response?.page,
            total_records: data?.response?.total_records,
            total_pages: data?.response?.total_pages
          })
        } else {
        }
      })
      .catch(function (error) {
        console.log('error', error)
      })
  }

  useEffect(() => {
    getList()
  }, [])

  const handleDelete = company_salary_head_id => {
    const headers = apiHeaderJSON
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        let data = {
          company_salary_head_id: company_salary_head_id
        }
        // console.log("delete handle called");
        axios
          .post(`${apiURL}Payrolls/DeleteSalaryHead`, data, {
            headers
          })
          .then(response => {
            const { success } = response.data
            console.log('handleDelete ~ response =======>>>', response)
            if (success === true) {
              Swal.fire({
                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                text: response.data.message,
                icon: success ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false // Show OK button
              }).then(result => {
                if (result.isConfirmed) {
                  getList()
                }
              })
            } else {
              Swal.fire({
                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                text: response.data.message,
                icon: success ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false // Show OK button
              }).then(result => {
                if (result.isConfirmed) {
                }
              })
            }
          })
      }
      // else {
      //     Swal.fire({
      //         title: 'Cancelled',
      //         text: 'Cancelled Delete..',
      //         icon: 'info',
      //         timer: 1500,
      //         showConfirmButton: false
      //     });
      //     return; // Do nothing if the user cancels
      // }
    })
    // Swal({
    //     title: "Are you sure?",
    //     text: "Once deleted, you will not be able to recover this item!",
    //     icon: "warning",
    //     buttons: true,
    //     dangerMode: true,
    // }).then((willDelete) => {
    //     if (willDelete) {
    //         let data = {
    //             company_salary_head_id: company_salary_head_id,
    //         };
    //         const headers = apiHeaderJSON;
    //         console.log(data);

    //     }
    // });
  }
  const handleToggleSwitch = (mail_id, toggleButton) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to change head status to ${
        toggleButton ? 'On' : 'Off'
      }`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No!',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        const data = {
          mail_template_id: mail_id,
          template_status: toggleButton ? '1' : '0',
          date: currentDateAndTime()
        }
        const headers = apiHeaderJSON
        console.log(data)
        axios
          .post(`${apiURL}MailMaster/HandleTemplateAccess`, data, {
            headers
          })
          .then(response => {
            const { success } = response.data
            // console.log('handleToggleSwitch ~ response =======>>>', response)
            if (success === true) {
               getList();
            } else {
                Swal.fire({
                    title: `<strong>"Failed"</strong>`,
                    text: response?.data?.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                  });
            }
          })
      }
      // else {
      //     Swal.fire({
      //         title: 'Cancelled',
      //         text: 'Cancelled..',
      //         icon: 'info',
      //         timer: 1500,
      //         showConfirmButton: false
      //     });
      //     return; // Do nothing if the user cancels
      // }
    })
  }

  useEffect(()=>{
    if(limitAction){
      getList();
      setLimitAction(false)
    }
  },[limitAction]);

  const handleLimitChange = e => {
    console.log(e.target.value)
    setPagination({
      ...pagination,
      limit: e.target.value,
      page: 1
    })
    setLimitAction(true)
  }
  const handlePageChange = e => {
    console.log(e.target.value)
    setPagination({
      ...pagination,
      page: parseInt(e.target.value)
    })
    setLimitAction(true)
  }
  const handlePrev = () => {
    console.log(pagination?.prev)
    if (pagination?.prev === true) {
      console.log(pagination?.page - 1)
      setPagination({
        ...pagination,
        page: pagination?.page - 1
      })
    }
    setLimitAction(true)
  }
  const handleNext = () => {
    console.log(pagination?.next)
    if (pagination?.next === true) {
      console.log(pagination?.page + 1)
      setPagination({
        ...pagination,
        page: pagination?.page + 1
      })
    }
    setLimitAction(true)
  }

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <br />
          <PageTitle title={`Email Template Master`} primary={`Home`} />
          <div className='row'>
            <div className='col-md-12'>
              <div className='card'>
                <div className='card-header align-items-center d-flex'>
                  <h4 className='card-title mb-0 flex-grow-1'>
                    Email Templates
                  </h4>
                  { decodedData?.includes(2) && ( 
                  <NavLink to={`/CreateEmail`} className='btn btn-success'>
                    Add
                  </NavLink>)}
                </div>
                <div className='col-md-12'>
                  <table className={`table table-bordered table-stripped`}>
                    <thead className='table-light'>
                      <tr>
                        <th>Sr.No.</th>
                        <th width={`30%`}>Mail Title</th>
                        <th width={`60%`}>Mail Subject</th>
                        <th >Status</th>
                        { decodedData?.includes(3) && ( 
                        <th width={`10%`} className=' text-center'>
                          Action
                        </th>)}
                      </tr>
                    </thead>
                    {!loadingList ? (
                      rows?.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={12}>
                              <NoRecords />
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {rows?.map((row, idx) => {
                            return (
                              <tr key={row?.mail_template_id}>
                                <td>{idx + 1}</td>
                                <td>{row?.mail_template_title}</td>
                                <td>{row?.mail_subject}</td>
                                <td>
                                  <div>
                                    <ToggleSwitch
                                      isActive={
                                        row?.template_status == "1" ? true : false
                                      }
                                      isExtFunc={true}
                                      onToggle={() => {
                                        handleToggleSwitch(
                                          row.mail_template_id,
                                          row?.template_status == "1" ? false : true
                                        )
                                      }}
                                    />
                                  </div>
                                </td>
                                { decodedData?.includes(3) && ( 
                                <td className='d-flex justify-content-around'>
                                { decodedData?.includes(3) && ( 
                                  <NavLink
                                    to={`/CreateEmail?id=${row?.mail_template_id}`}
                                    type='button'
                                    className='btn-icon btn btn-sm btn-outline-primary'
                                  >
                                    {' '}
                                    <i className='ri-edit-box-line'></i>{' '}
                                  </NavLink>)}
                                  {/* <button onClick={() => handleDelete(row?.mail_template_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                  {/*<button onClick={() => setCompanyInfo({ company_salary_head_id: row.company_salary_head_id })} className="btn-icon btn btn-sm btn-outline-success" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="ri-file-info-line"></i> </button> */}
                                </td>)}
                              </tr>
                            )
                          })}
                        </tbody>
                      )
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={12}>
                            <div className='text-center mt-3'>
                              <span className='text-info'>
                                <i className='mdi mdi-loading mdi-spin fs-1 align-middle me-2' />{' '}
                                Loading.....
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    )}

                    <tfoot className='table-light'>
                      <tr>
                        <th colSpan={8}>
                          <div className='d-flex justify-content-between'>
                            <button
                              disabled={!pagination?.prev}
                              type='button'
                              onClick={() => handlePrev()}
                              className={`btn btn-warning btn-label waves-effect waves-light`}
                            >
                              <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2' />{' '}
                              Previous
                            </button>
                            <div
                              className='col-md-4'
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              {
                                <small>
                                  Total Records: {pagination?.total_records} |
                                  Total Pages: {pagination?.total_pages} |
                                  Current Page: {pagination?.page}
                                </small>
                              }
                            </div>
                            <div className='col-md-2'>
                              <select
                                className='form-select'
                                onChange={e => {
                                  handlePageChange(e)
                                }}
                              >
                                {Array.from(
                                  { length: pagination?.total_pages },
                                  (_, i) => (
                                    <option
                                      selected={pagination?.page === i + 1}
                                      key={i}
                                      value={i + 1}
                                    >
                                      Page {i + 1}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                            <div className='col-md-2'>
                              <select
                                className='form-select'
                                onChange={handleLimitChange}
                                value={pagination?.limit}
                              >
                                {limitOptions.map(option => (
                                  <option key={option} value={option}>
                                    Limit {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <button
                              disabled={!pagination?.next}
                              type='button'
                              onClick={() => handleNext()}
                              className={`btn btn-primary btn-label waves-effect right waves-light`}
                            >
                              <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2' />{' '}
                              Next
                            </button>
                          </div>
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MailList
